export default "__VITE_ASSET__DFewaRFg__"